export const Constants_solicitudes = {
  LISTA_TAMANIOS: 'Tamaño_Empresa',
  LISTA_TIPOS_SOCIEDAD: 'ICA_TIPO_SOCIEDAD',
  LISTA_MOTIVOS: 'Motivo_Rechazo_Empresa',
  ACCION_VERIFICAR: '1',
  ACCION_APROBAR: '2',
  ACCION_RECHAZAR: '3',
  MIN_TRES: 3,
  MAX_CINCUENTA: 50,
  MIN_CUATRO: 4,
  MAX_DOCE: 12,
  MAX_NUEVE: 9,
  MAX_CIEN: 100,
  STATUS_BAD_REQUEST: 400,
  OTRO_MOTIVO: 'OTRO MOTIVO',
  ASC: 'asc',
  DESC: 'desc',
  CERO: 0
}
